import { useEffect } from 'react';
import { Button, Card } from '@atoms/index';
import { cn } from '@/utils/cn';

export type ConfirmModalVariant = 'default' | 'danger' | 'warning' | 'success';

export function ConfirmModal(props: {
  isOpen: boolean;
  title: string;
  description: string;
  confirmText: string;
  cancelText?: string;
  isConfirmLoading?: boolean;
  variant?: ConfirmModalVariant;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const variant = props.variant || 'default';
  useEffect(() => {
    if (!props.isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') props.onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [props.isOpen, props.onClose]);

  if (!props.isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center px-4">
      <button className="absolute inset-0 bg-black/50" onClick={props.onClose} aria-label="Modal kapat" />
      <Card className="relative z-[10000] w-full max-w-md p-0 overflow-hidden">
        <div className="p-6">
          <h3 className="text-xl font-bold text-gray-900 mb-2">{props.title}</h3>
          <p className="text-gray-600 mb-6">{props.description}</p>
          <div className="flex gap-3">
            <Button variant="secondary" className="w-full" onClick={props.onClose} disabled={props.isConfirmLoading}>
              {props.cancelText || 'Vazgeç'}
            </Button>
            <Button 
              className={cn(
                'w-full',
                variant === 'danger' && 'bg-red-600 hover:bg-red-700',
                variant === 'warning' && 'bg-yellow-600 hover:bg-yellow-700',
                variant === 'success' && 'bg-green-600 hover:bg-green-700'
              )}
              onClick={props.onConfirm} 
              isLoading={props.isConfirmLoading}
            >
              {props.confirmText}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}

